import { Directive, HostListener, Input } from '@angular/core';
import { InlineTableCellEditComponent } from '@modeso/aumico-lib-core-fe';
import { MenuAction } from '../enums/menu-action.enum';

@Directive({
    selector: '[editCell]',
})
export class EditCellDirective {
    @Input('editCell') cellComponent: InlineTableCellEditComponent;

    @HostListener('click', ['$event.target']) onClick(target: HTMLElement) {
        if (this.cellComponent == undefined) return;
        if (target.id === MenuAction.EDIT || target.parentElement.id === MenuAction.EDIT) {
            this.cellComponent.handleOnEdit();
        }
    }
}
